import * as React from "react"

import { MobileNav } from "./MobileNav"
import { Sidebar } from "./Sidebar"

/**
 * Creates a Navigation component that displays the appropiate navigation bar depending on the screen size
 * @returns {JSX.Element} Returns the Navigation component
 */
const Navigation = () => {
  return (
    <>
      <div className="fixed top-0 left-0 z-50 block w-full 2xl:hidden">
        <MobileNav />
      </div>
      <div className="hidden 2xl:block">
        <Sidebar />
      </div>
    </>
  )
}

export default Navigation
